import { render, staticRenderFns } from "./materials-import.vue?vue&type=template&id=718975a0"
import script from "./materials-import.vue?vue&type=script&lang=js"
export * from "./materials-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports